import React,{useEffect,useRef,useState} from 'react';
import api from '../../api/api';
import './galleryVideo.css';

export function VideoPlayer({src}) {
 const ref=useRef(null),[duration,setDuration]=useState(0);
 const seek=delta=>{const v=ref.current;if(v)v.currentTime=Math.min(Number.isFinite(v.duration)?v.duration:0,Math.max(0,v.currentTime+delta));};
 return <div className="gallery-video-player">
  <video ref={ref} src={src} controls playsInline preload="metadata" onLoadedMetadata={()=>setDuration(ref.current?.duration||0)} aria-label="Gallery video"/>
  <div className="gallery-video-controls"><button onClick={()=>seek(-5)}>Back 5s</button><button onClick={()=>{const v=ref.current;if(v.paused)v.play().catch(()=>{});else v.pause();}}>Play / Pause</button><button onClick={()=>seek(5)}>Forward 5s</button><span>{Number.isFinite(duration)?Math.ceil(duration):0}s</span></div>
 </div>;
}
function useMedia({galleryId,dataDocId,part,actionId,kind,revision}) {
 const [url,setUrl]=useState(''),[blob,setBlob]=useState(null),[failed,setFailed]=useState(false);
 useEffect(()=>{
  let stopped=false,objectUrl;setUrl('');setBlob(null);setFailed(false);
  const endpoint=actionId?`/public/actions/${actionId}/test/result-media`:'/gallery/photo-share/manage';
  api.post(endpoint,{galleryId,dataDocId,part,...(kind?{kind}: {})},{responseType:'blob'}).then(({data})=>{
   if(stopped)return;if(!(data instanceof Blob)||!data.size)throw Error('Media unavailable');
   objectUrl=URL.createObjectURL(data);setUrl(objectUrl);setBlob(data);
  }).catch(()=>{if(!stopped)setFailed(true);});
  return()=>{stopped=true;if(objectUrl)URL.revokeObjectURL(objectUrl);};
 },[galleryId,dataDocId,part,actionId,kind,revision]);return {url,blob,failed};
}
export function VideoPoster(props) {
 const {url,failed}=useMedia({...props,part:'poster'}),[decodeFailed,setDecodeFailed]=useState(false);
 useEffect(()=>setDecodeFailed(false),[url]);
 return <div className="gallery-video-poster">{url&&!decodeFailed?<img src={url} alt="Video preview" onError={()=>setDecodeFailed(true)}/>:<span className="gallery-video-placeholder">{failed||decodeFailed?'Video preview unavailable':'Loading video preview...'}</span>}<span className="gallery-video-play" aria-label="Play video"><svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 3 L21 12 L7 21 Z" fill="currentColor"/></svg></span></div>;
}
export default function GalleryVideo(props) {
 const {url,blob,failed}=useMedia(props),[message,setMessage]=useState('');
 const ext={'video/mp4':'mp4','video/quicktime':'mov','video/webm':'webm'}[blob?.type];
 const file=blob&&ext?new File([blob],`EveryID-video.${ext}`,{type:blob.type}):null;
 function share(){
  if(!file)return;
  try{if(!navigator.share || !navigator.canShare?.({files:[file]})){setMessage('Save Video to share from Photos or Files, or use the Gallery QR.');return;}
   Promise.resolve(navigator.share({files:[file],title:'EveryID video'})).catch(e=>{if(e?.name!=='AbortError')setMessage('Use Save Video or the Gallery QR to share.');});
  }catch(e){if(e?.name!=='AbortError')setMessage('Use Save Video or the Gallery QR to share.');}
 }
 return url?<><VideoPlayer src={url}/>{props.allowDownload&&file&&<div className="gallery-video-controls"><button onClick={share}>Share Video</button><a href={url} download={file.name}>Save Video</a></div>}{message&&<p role="status">{message}</p>}</>:<p role="status">{failed?'Video unavailable. Check access or reopen the Gallery.':'Loading video...'}</p>;
}

export function CapturePhoto(props) {
 const {url,failed}=useMedia({...props,kind:'photo'});
 return url?<img src={url} alt="Captured photograph"/>:<span>{failed?'Photo unavailable':'Loading photo...'}</span>;
}
